<template>
  <a-layout class="pr-layout-wrap">
    <PrHeader :hasMenus="false" />
    <a-layout>
      <pr-sider />
      <a-layout-content>
        <vab-content />
        <PrLayoutFooter mode="admin" />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
  import VabContent from './vab-content'
  import PrHeader from './pr-header'
  import PrLayoutFooter from './pr-footer'
  import PrSider from './pr-sider/admin.vue'
  import 'remixicon/fonts/remixicon.css'

  export default {
    components: {
      VabContent,
      PrSider,
      PrLayoutFooter,
      PrHeader,
    },
    data() {
      return {}
    },
  }
</script>
<style lang="less" scoped>
  @import url('@/styles/params.less');
  .pr-layout-wrap {
    /*
      left: 208px
      content: 1000px
      margin: 16px
     */
    min-width: 1240px;
  }
  .app-breadcrumb {
    background-color: white;
    padding: 12px 32px 12px 32px;
    font-size: 14px;
    color: #666666;
    .page-header {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 4px 0;
    }
    .page-remark {
      display: flex;
      align-items: center;
    }
    .page-title {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 28px;
      font-weight: bold;
    }
  }
</style>
